<template>
  <div class="copilot-float-wrapper">
    <!-- Sentinel: elemento invisible que el observer monitorea -->
    <div ref="sentinel" class="copilot-sentinel"></div>

    <!-- Barra de Mydessk IA -->
    <div
      class="copilot-float-bar"
      :class="{ 'is-floating': isFloating, 'is-docked': !isFloating }"
      @click="focusInput"
    >
      <div class="cfb-inner" :class="{ 'is-focused': isFocused }">
        <!-- Fila superior: icono + textarea + boton enviar -->
        <div class="cfb-top">
          <div class="cfb-icon" @click.stop="openCopilot(null)">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#fff"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M12 3l1.912 5.813a2 2 0 001.275 1.275L21 12l-5.813 1.912a2 2 0 00-1.275 1.275L12 21l-1.912-5.813a2 2 0 00-1.275-1.275L3 12l5.813-1.912a2 2 0 001.275-1.275L12 3z"
              />
            </svg>
          </div>

          <textarea
            ref="inputRef"
            v-model="inputText"
            class="cfb-input"
            placeholder="Pregunta a Mydessk IA sobre tu negocio o como usar la plataforma..."
            rows="1"
            @keydown.enter.exact.prevent="send"
            @focus="isFocused = true"
            @blur="isFocused = false"
            @input="autoResize"
          ></textarea>

          <button
            class="cfb-send"
            :disabled="!inputText.trim()"
            @click.stop="send"
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#fff"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="22" y1="2" x2="11" y2="13" />
              <polygon points="22 2 15 22 11 13 2 9 22 2" />
            </svg>
          </button>
        </div>

        <!-- Fila inferior: chips de sugerencia -->
        <div class="cfb-chips">
          <div
            v-for="chip in suggestions"
            :key="chip"
            class="cfb-chip"
            @click.stop="sendChip(chip)"
          >
            {{ chip }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CopilotFloatingBar",
  data() {
    return {
      inputText: "",
      isFocused: false,
      isFloating: true,
      observer: null,
      suggestions: [
        "\u00bfC\u00f3mo va el mes?",
        "\u00bfA qui\u00e9n contactar?",
        "Cotizaci\u00f3n a factura",
        "\u00bfCu\u00e1nto puedo cerrar?"
      ]
    };
  },
  mounted() {
    this.initObserver();
  },
  beforeDestroy() {
    if (this.observer) this.observer.disconnect();
  },
  methods: {
    initObserver() {
      this.observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            this.isFloating = !entry.isIntersecting;
          });
        },
        { root: null, threshold: 0 }
      );
      if (this.$refs.sentinel) {
        this.observer.observe(this.$refs.sentinel);
      }
    },
    focusInput() {
      if (this.$refs.inputRef) this.$refs.inputRef.focus();
    },
    autoResize(e) {
      const el = e.target;
      el.style.height = "auto";
      el.style.height = Math.min(el.scrollHeight, 100) + "px";
    },
    send() {
      const text = this.inputText.trim();
      if (!text) return;
      this.openCopilot(text);
      this.inputText = "";
      if (this.$refs.inputRef) {
        this.$refs.inputRef.style.height = "auto";
      }
    },
    sendChip(chip) {
      this.openCopilot(chip);
    },
    openCopilot(initialText) {
      this.$store.dispatch("copilot/open", initialText ? { initialText } : {});
    }
  }
};
</script>

<style scoped lang="scss">
.copilot-float-wrapper {
  display: contents;
}

.copilot-sentinel {
  height: 1px;
  width: 100%;
  pointer-events: none;
}

.copilot-float-bar {
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  border-top: 0.5px solid rgba(0, 0, 0, 0.08);
  padding: 12px 20px 14px;
  z-index: 50;
  transition: box-shadow 0.2s ease;
}

.copilot-float-bar.is-floating {
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.07);
}

.copilot-float-bar.is-docked {
  box-shadow: none;
}

.cfb-inner {
  max-width: 800px;
  margin: 0 auto;
  background: #f7f8fc;
  border: 0.5px solid rgba(0, 0, 0, 0.12);
  border-radius: 14px;
  padding: 12px 16px;
  transition: border-color 0.15s, background 0.15s;
  cursor: text;
}

.cfb-inner.is-focused {
  border-color: #3ecfb4;
  background: #fff;
}

.cfb-top {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 10px;
}

.cfb-icon {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #2d2b55;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 2px;
  cursor: pointer;
  transition: background 0.15s;
  &:hover {
    background: #3ecfb4;
  }
}

.cfb-input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 13px;
  color: #303133;
  background: transparent;
  font-family: inherit;
  line-height: 1.6;
  resize: none;
  height: 34px;
  max-height: 100px;
  padding-top: 7px;
  &::placeholder {
    color: #909399;
  }
}

.cfb-send {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #3ecfb4;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 2px;
  transition: background 0.15s;
  &:hover {
    background: #1d9e75;
  }
  &:disabled {
    background: #d3d1c7;
    cursor: not-allowed;
  }
}

.cfb-chips {
  display: flex;
  gap: 5px;
  padding-left: 44px;
  flex-wrap: wrap;
}

.cfb-chip {
  font-size: 11px;
  padding: 4px 11px;
  border-radius: 20px;
  border: 0.5px solid rgba(0, 0, 0, 0.12);
  color: #606266;
  background: #fff;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
  &:hover {
    border-color: #2d2b55;
    color: #2d2b55;
  }
}

@media (max-width: 768px) {
  .copilot-float-bar {
    padding: 10px 12px 12px;
  }
  .cfb-inner {
    padding: 10px 12px;
  }
  .cfb-chips {
    padding-left: 0;
    overflow-x: auto;
    flex-wrap: nowrap;
    -webkit-overflow-scrolling: touch;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .cfb-input {
    font-size: 14px;
  }
}
</style>
